import { FC } from 'react';
import styled, { css } from 'styled-components';
import CheckIcon from '../../icons/Check';

/* eslint-disable @typescript-eslint/no-unused-vars */
const ComponentWithProps: FC<{ readOnly?: boolean }> = ({
  readOnly,
  ...props
}) => {
  return <label {...props} />;
};

const Container = styled(ComponentWithProps)`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: fit-content;

  ${({ readOnly }) =>
    readOnly
      ? css`
          cursor: default !important;
          & * {
            cursor: default !important;
          }
        `
      : ''}
`;

const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  &:checked ~ span {
    border: 1px solid var(--primary-600);
    stroke: var(--primary-600);
  }

  &:focus ~ span {
    outline: var(--outline);
  }
`;

const Checkmark = styled.span`
  display: grid;
  place-items: center;
  border: 1px solid var(--gray-300);
  stroke: transparent;
  height: 1.25rem;
  width: 1.25rem;
  border-radius: 6px;
  outline-width: 1px !important;
`;

type Props = {
  name?: string;
  checked?: boolean;
  readOnly?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  value?: string;
  tabIndex?: number | undefined;
};
const Checkbox: FC<Props> = ({
  name,
  checked,
  onChange,
  readOnly,
  value,
  tabIndex,
}) => {
  return (
    <Container readOnly={readOnly}>
      <Input
        name={name}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        readOnly={readOnly}
        value={value}
        tabIndex={readOnly ? -1 : tabIndex}
      />
      <Checkmark>
        <CheckIcon />
      </Checkmark>
    </Container>
  );
};

export default Checkbox;
